import React from 'react';
import {
    Radar,
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
} from 'recharts';
import CustomPolarAngleAxisTick from "./CustomPolarAngleAxisTick";
import CustomRadiusTick from "./CustomPolarRadiusAxisTick";

interface SkillData {
    groupTitle: string,
    totalPoint: number,
    totalQuestion: number,
    advice: string,
    avgPoint: number,
    stdevpPoint: number,
    deviation: number,
    exposition: string,
    acronym?: string,
}

const RadarChartComponent: React.FC<{ data: SkillData[] }> = ({ data }) => {
    const fixedFillData = data.map((item) => ({
        ...item,
        fixedValue: 50,
    }));

    return (
        <RadarChart
            cx={150}
            cy={150}
            outerRadius={90}
            width={300}
            height={300}
            data={fixedFillData}
        >
            <PolarGrid radialLines={true} stroke="#CCCCCC" />
            <PolarAngleAxis dataKey="acronym" tick={<CustomPolarAngleAxisTick />} />
            <PolarRadiusAxis
                angle={90}
                domain={[20, 80]}
                tickCount={7}
                tickFormatter={(value) => {
                    if (value === 20) return "20";
                    if (value === 30) return "30";
                    if (value === 40) return "40";
                    if (value === 50) return "50";
                    if (value === 60) return "60";
                    if (value === 70) return "70";
                    if (value === 80) return "80";
                    return "";
                }}

                tick={<CustomRadiusTick/>}
            />
            <Radar
                name="平均点"
                dataKey="fixedValue"
                stroke="#4682B4"
                strokeWidth={2}
                fill="white"
                fillOpacity={0}
            />
            <Radar
                name="個人平均"
                dataKey="deviation"
                stroke="#F25A5A"
                strokeWidth={2}
                fill="#F25A5A26"
                fontWeight={"bold"}
                fillOpacity={0.6}
            />
        </RadarChart>
    );
};

export default RadarChartComponent;
